<script setup lang="ts">
defineProps<{
    title: string;
}>();
</script>

<template>
    <div class="menu-section">
        <div class="menu-section-title">{{ title }}</div>
        <v-list class="bg-transparent pa-0">
            <slot></slot>
        </v-list>
    </div>
</template>
